module.exports = __webpack_public_path__ + "img/footer-link-11.c8527dbe.png";